import { helpCenterBreakpoints } from 'help-center/mixins/constants.module.scss'

export default parse(helpCenterBreakpoints)

function parse(sassJSON) {
  const unwrapped = sassJSON.replace(/^['"]|['"]$/g, '')
  return JSON.parse(unwrapped)
}
